import React from 'react'
import _ from 'underscore'
import { ReceiptText } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import Timeago from '../../../../timeago'
import store from '../../../../../state/store'

const HEADING_CLASSES = 'mb-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground'

const statusVariant = (status) => {
  if (status === 'paid') return 'success'
  if (status === 'unpaid') return 'warning'
  return 'secondary'
}

class LessonOrderSummary extends React.Component {

  onOpen = () => {
    store.emit('lesson_plan:lesson_order:open', this.props.lesson_order)
  }

  onShare = () => {
    store.emit('lesson_plan:lesson_order:share', this.props.lesson_plan.id, this.props.lesson_order.id)
  }

  render() {
    const lesson_order = this.props.lesson_order

    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex flex-wrap items-center gap-2" title={`Lesson Order #${this.props.lesson_order.id}`}>
            <ReceiptText className="size-4"/>
            Lesson Order
            <Badge variant={statusVariant(lesson_order.workflow_state)} size="md" className="capitalize">{lesson_order.workflow_state}</Badge>
            <Badge variant={statusVariant(lesson_order.payment_status)} size="md" className="capitalize">{lesson_order.payment_status}</Badge>
            {lesson_order.attached_to_order ?
              <Badge variant="secondary" size="md">Order {lesson_order.active_order.id}</Badge>
              : null
            }
          </CardTitle>
          <CardDescription>created <Timeago date={lesson_order.created_at} /></CardDescription>
          <CardAction className="ml-auto self-center text-right">
            <span className="flex justify-end gap-2">
              {(lesson_order.url) ?
                <Button size="sm" onClick={this.onOpen}>Open Customer View</Button>
                : null
              }
              <Button size="sm" onClick={this.onShare}>Share</Button>
            </span>
            {lesson_order.shared_at ?
              <div className="mt-1 text-[13px] text-muted-foreground">Last Shared: <Timeago date={lesson_order.shared_at} /></div>
              : null
            }
          </CardAction>
        </CardHeader>
        <CardContent className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          <div>
            <p className={HEADING_CLASSES}>Customer</p>
            <p className="font-medium"><Badge variant="secondary" size="md">{lesson_order.customer_name}</Badge></p>
          </div>
          <div>
            <p className={HEADING_CLASSES}>Learner</p>
            <p className="font-medium"><Badge variant="secondary" size="md">{lesson_order.learner_names}</Badge></p>
          </div>
          <div>
            <p className={HEADING_CLASSES}>Tutor Tier</p>
            <p className="font-medium"><Badge variant="secondary" size="md">{(lesson_order.tutor_tier || '').split('_').join(' ')}</Badge></p>
          </div>
          <div>
            <p className={HEADING_CLASSES}>Subject Category</p>
            <p className="font-medium"><Badge variant="secondary" size="md">{lesson_order.subject_category_name}</Badge></p>
          </div>
          <div>
            <p className={HEADING_CLASSES}>Learners per Lesson</p>
            <p className="font-medium"><Badge variant="secondary" size="md">{lesson_order.learners_per_lesson}</Badge></p>
          </div>
          <div>
            <p className={HEADING_CLASSES}>Subjects</p>
            <p className="flex flex-wrap gap-1 font-medium">
              {_.map(lesson_order.subject_names, function (subject_name) {
                return (
                  <Badge key={subject_name} variant="secondary" size="md">{subject_name}</Badge>
                )
              })}
            </p>
          </div>
          <div>
            <p className={HEADING_CLASSES}>Lesson Location</p>
            <p className="font-medium"><Badge variant="secondary" size="md">{lesson_order.lesson_location}</Badge></p>
          </div>
        </CardContent>
      </Card>
    );
  }
}

export default LessonOrderSummary
